<template>
  <div>
    <div>
      <div class="mian">
        <!-- 头部 -->
        <!-- <div class="top">
      <img src="../assets/images/头部框.png" alt="">
      <div class="info">
        <span>{{ dataList.trace_name }}</span>
      </div>
      <div class=num>
        <span>0{{ dataList.sort - 1 }}</span>
      </div>
    </div> -->
        <div class="slot">
          <Diy :list="dataList" />
        </div>
        <!-- <div class="goods-characteristic">
          <div class="goods-characteristic-inner">
            <span @click="toBlockChain">
              区块链标识：{{ dataList.msgItems[0].txid }}</span
            >
          </div>
        </div> -->
        <div class="goodsInfo-text">
          <div class="goods-title" style="width: 200px">区块链标识</div>
          <div class="goodsInfo-text-num texts" style="word-wrap: break-word">
            {{ dataList.msgItems[0].txid }}
          </div>
        </div>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper">
        <sertificate :ts="ts" :txid="txid" />
        <div style="margin-top: 10px" @click="show = false">
          <img src="../assets/images/关闭按钮.png" alt="" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem, Overlay } from "vant";
import Sertificate from "../components/Sertificate.vue";

import Diy from "./diy.vue";

Vue.use(Overlay);
Vue.use(Swipe);

Vue.use(SwipeItem);
export default {
  props: {
    dataList: {
      type: Object,
    },
  },
  data() {
    return {
      listData: [],
      list: [],
      data: [],
      obj: {},
      new: [],
      show: false,
      ts: "",
      txid: "",
    };
  },
  created() {},
  methods: {
    toBlockChain() {
      this.show = true;
      this.ts = this.dataList.msgItems[0].ts;
      this.txid = this.dataList.msgItems[0].txid;
      // this.$router.push(
      //   `/Look?ts=${this.dataList.msgItems[0].ts}&txid=${this.dataList.msgItems[0].txid}`
      // );
    },
  },
  components: { Diy, Sertificate },
};
</script>

<style lang="scss" scoped>
.goodsInfo-text-num {
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
}
.texts {
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 400;
  margin-left: 60px;
  color: #000000;
  opacity: 1;
}
.goodsInfo-text {
  margin-top: 30px;
  display: flex;
  margin-left: 20px;
  .goods-title {
    width: 100px;
  }
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mian {
  position: relative;
  width: 608px;
  margin-bottom: 20px;
  padding: 0 16px 0 16px;
  background-color: #fff;
  .f-box {
    .video {
      width: 500px;
      height: 282px;
      margin: 0 auto;
    }
    .t-text {
      font-size: 24px;
      width: 544px;
      margin: 0 auto;
      font-weight: 400;
      line-height: 52px;
      color: #292c40;
      opacity: 1;
    }
    margin-bottom: 46px;
    .title {
      width: 544px;
      height: 56px;
      background: #f5f6f6;
      border: 2px solid #f5f6f6;
      margin: 0 auto;
      margin-bottom: 24px;
      font-size: 34px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 52px;
      color: #292c40;
      opacity: 1;
    }
    .t-pic {
      margin: 0 auto;
      width: 500px;
      height: 280px;
      background: #ffffff;
      border: 2px solid #707070;
      margin-bottom: 20px;
    }
  }
  .top {
    position: relative;
    margin-bottom: 10px;
    img {
      width: 100%;
    }
    .info {
      position: absolute;
      top: 9vw;
      left: 6vw;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #fff;
      opacity: 1;
    }
    .num {
      color: transparent;
      -webkit-text-stroke: 1px #127855;
      font-size: 11vw;
      position: absolute;
      top: 15px;
      left: 240px;
    }
  }
  .license {
    display: flex;
    width: 621px;
    height: 451px;

    margin: 0 auto;
    margin-bottom: 20px;
  }
  .pic {
    .my-swipe {
      width: 100%;
      height: 100%;
    }
    width: 574px;
    height: 409px;

    margin: auto;
  }
  .goods {
    margin-top: 20px;
    width: 694px;
  }
  .goodsInfo2 {
    height: 218px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0px;
    color: #919ab1;
    opacity: 1;
  }
  .goodsInfo3 {
    height: 185px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0px;
    color: #919ab1;
    opacity: 1;
  }
  .goodsInfo4 {
    height: 131px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 0px;
    color: #919ab1;
    opacity: 1;
  }
  .goodsInfo {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 694px;
    border: 2px solid #f3f3f3;
    opacity: 1;

    .goodsInfo-text {
      margin-left: 20px;
    }
    .texts {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0px;
      color: #000000;
      opacity: 1;
    }
  }
  .goods-top {
    width: 682px;
    height: 56px;
    background: #f5f6f6;
    border: 2px solid #f5f6f6;
    opacity: 1;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 56px;
    color: #292c40;
    padding-left: 10px;
  }
  .goods-characteristic {
    margin: 0 auto;
    width: 536px;
    padding-bottom: 20px;
    .goods-characteristic-inner {
      margin: 0 auto;
      line-height: 38px;
      padding: 12px 30px;
      font-size: 28px;
      color: #11745f;
      border: 1px solid #11745f;
      border-radius: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .material {
    display: flex;
    justify-content: space-between;
    width: 690px;
    height: 49px;
    background-color: skyblue;
    align-items: center;
    margin: 2 auto;
    border-bottom: 2px solid #e8e8e8;
    .dian {
      width: 12px;
      height: 12px;
      background: #000000;
      border-radius: 50%;
      opacity: 1;
      margin-right: -330px;
    }
    .date {
      width: 210px;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: #919ab1;
      opacity: 1;
    }
  }
}
</style>